<template>
  <b-modal
    ref="modal"
    title="Replace or upload as new file:"
    centered
    @hide="closeHandler"
    @ok="ok"
  >
    One or more items already exists in this location. Do you want to replace the existing items with a new version or keep both items?

    <ul 
      class="text-break"
    >
      <li
        v-for="file in files"
        :key="file.id"
      >
        {{ file.data?.name_only }}
      </li>
    </ul>

    <b-form-group>
      <b-form-radio
        v-model="selected"
        :value="1"
      >
        Replace existing items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="2"
      >
        Keep all items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="3"
      >
        Stop
      </b-form-radio>
    </b-form-group>
  </b-modal>
</template>

<script>
import mixinModal from "./mixin";
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "FileExistsModal",
  mixins: [
    mixinModal
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({
        files: []
      })
    }
  },
  data: () => ({
    selected: 2,
  }),
  computed: {
    files() {
      return this.payload?.files || []
    }
  },
  methods: {
    ...mapActions([
      'uploadFiles'
    ]),
    async ok() {
      if (!this.files.length) {
        return;
      }

      try {
        await this.uploadFiles({
          files: this.files.map(({ file, company_id }) => {
            file.company_id = company_id;
            return file;
          }),
          replace: this.selected
        });
      } catch (error) {
        console.error('Failed to upload files:', error);
        this.$bvToast.toast('Failed to upload files. Please try again.', {
          title: 'Upload Error',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
